import { BaseType } from '../base/base-type';
import { TaxProfileSourceTypeIdEnum } from './tax-profile-source-type-id.enum';

export class TaxProfileSourceType extends BaseType {
  public declare id: TaxProfileSourceTypeIdEnum;
}
